export default __webpack_public_path__ + "static/business-model-1330c73b11c2e72e1cf7300d404de840.png";